






















import { Vue, Component } from 'vue-property-decorator'
import { getStore } from '@/utils/utils'
@Component
export default class phoneResultShow extends Vue {
  resultContent: string = ''
  mounted() {
    this.$toast.clear()
    let mobile = getStore('userInfo') ? JSON.parse(getStore('userInfo')).mobile : ''
    this.resultContent = `您的手机号更换为${mobile}`
  }
  buttonHandel(val: string) {
    this.$router.replace('/yue-accountManage')
  }
}
